module.exports = __webpack_public_path__ + "img/employ_2.7aa24e94.png";